import { forwardRef } from 'react';
import {
  Pressable,
  PressableProps,
  StyleProp,
  View,
  ViewStyle,
} from 'react-native';

interface PressableNeolexonProps extends PressableProps {
  enableFlicker?: boolean;
  opacityLevel?: number;
  style?: StyleProp<ViewStyle>;
}

export const PressableNeolexon = forwardRef<View, PressableNeolexonProps>(
  (
    {
      onPress,
      onPressIn,
      disabled = false,
      children,
      style,
      enableFlicker = true,
      opacityLevel = 0.2,
      ...viewProps
    },
    ref,
  ) => {
    return (
      <Pressable
        {...viewProps}
        ref={ref}
        onPress={onPress}
        onPressIn={onPressIn}
        disabled={disabled}
        style={({ pressed }) => [
          !onPressIn
            ? { opacity: pressed && enableFlicker ? opacityLevel : 1 }
            : undefined,
          style,
        ]}
      >
        {children}
      </Pressable>
    );
  },
);
PressableNeolexon.displayName = 'PressableNeolexon';
